import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  CheckboxInput,
  InputBlock,
  formatPhoneNumber,
  SharedFormMessages as formMessages,
} from 'ecs-react-components/dist/index.es';
import { messages } from './ContactInformation.i18n';

class ContactInformation extends React.Component {
  componentDidMount = () => {
    this.setNewContactDefaultLanguage();
  }

  setNewContactDefaultLanguage = () => {
    const { defaultLanguageId, preferredCommunicationLanguages } = this.props;
    const defaultLanguage = preferredCommunicationLanguages.filter((lang) => lang.languageId === defaultLanguageId);
    const defaultLanguageEnabled = defaultLanguage.length > 0;
    if (!this.props.isEditMode && defaultLanguageEnabled) {
      this.props.fields.communicationLanguageId.input.onChange(defaultLanguageId);
    }
  }

  createLanguageOptions = (language) => {
    const option = {};
    option.key = language.languageId;
    option.value = language.languageId;
    if (this.props.languageTranslations != null) {
      option.displayValue = this.props.languageTranslations[language.languageCode];
    } else {
      option.displayValue = language.displayName;
    }

    return option;
  }

  render() {
    const { fields, preferredCommunications, onPhoneChange, preferredCommunicationLanguages } = this.props;
    const { formatMessage } = this.props.intl;
    const filteredPreferredCommunications = preferredCommunications.filter(
      (communication) => communication.preferredCommunicationCode !== 'Fax');
    const preferredCommunicationsOptions = filteredPreferredCommunications.map((x) => {
      const option = {};
      option.key = x.preferredCommunicationId;
      option.value = x.preferredCommunicationId;
      option.displayValue = x.preferredCommunicationDisplay;
      return option;
    });

    const preferredCommunicationLanguageOptions = preferredCommunicationLanguages.map(this.createLanguageOptions);

    return (
      <div className="contact-section">
        <h4 tabIndex="0" className="mt-2"><FormattedMessage { ...messages.title } /></h4>
        <div className="row">
          <div className="form-group col mb-3">
            <InputBlock
              id="homePhone"
              labelText={ <FormattedMessage { ...messages.label.homePhone } /> }
              type="text"
              field={fields.homePhone}
              formGroup={false}
              onChange={onPhoneChange}
              value={formatPhoneNumber(fields.homePhone.input.value)}
              qaTag="homePhone"
            />
            <CheckboxInput
              type="checkbox"
              field={fields.isOkToLeaveMsgHome}
              qaTag="isMessageHome"
              small
            >
              <FormattedMessage { ...messages.message } />
            </CheckboxInput>
          </div>
          <div className="form-group col mb-3">
            <InputBlock
              id="mobilePhone"
              labelText={ <FormattedMessage { ...messages.label.mobilePhone } /> }
              type="text"
              field={fields.mobilePhone}
              formGroup={false}
              onChange={onPhoneChange}
              value={formatPhoneNumber(fields.mobilePhone.input.value)}
              qaTag="mobilePhone"
            />
            <CheckboxInput
              type="checkbox"
              field={fields.isOkToLeaveMsgMobile}
              qaTag="isMessageMobile"
              small
            >
              <FormattedMessage { ...messages.message } />
            </CheckboxInput>
          </div>
        </div>
        <div className="row">
          <div className="form-group col mb-3">
            <InputBlock
              id="workPhone"
              labelText={ <FormattedMessage { ...messages.label.workPhone } /> }
              type="text"
              field={fields.workPhone}
              formGroup={false}
              onChange={onPhoneChange}
              value={formatPhoneNumber(fields.workPhone.input.value)}
              qaTag="workPhone"
            />
            <CheckboxInput
              type="checkbox"
              field={fields.isOkToLeaveMsgWork}
              qaTag="isMessageWork"
              small
            >
              <FormattedMessage { ...messages.message } />
            </CheckboxInput>
          </div>
          <div className="form-group col mb-3">
            <InputBlock
              id="contactEmail"
              labelText={ <FormattedMessage { ...messages.label.email } /> }
              type="text"
              field={fields.contactEmail}
              formGroup={false}
              customMessage={<FormattedMessage { ...formMessages.error.email } />}
            />
          </div>
        </div>
        <div className="row">
          <div className="form-group col mb-3">
            <InputBlock
              type="select"
              labelText={ <FormattedMessage { ...messages.label.preferredContactMethod } /> }
              field={fields.preferredCommunicationId}
              options={preferredCommunicationsOptions}
              placeHolder={formatMessage(messages.placeholder.preferredContactMethod)}
              qaTag="preferredContactSelect"
              formGroup={false}
            />
          </div>
          <div className="form-group col mb-3">
            <InputBlock
              type="select"
              labelText={ <FormattedMessage { ...messages.label.preferredCommunicationLanguage } /> }
              field={fields.communicationLanguageId}
              options={preferredCommunicationLanguageOptions}
              qaTag="communicationLanguageSelect"
              formGroup={false}
              placeHolder={formatMessage(messages.placeholder.preferredCommunicationLanguage)}
            />
          </div>
        </div>
      </div>
    );
  }
}

ContactInformation.propTypes = {
  fields: PropTypes.object,
  intl: PropTypes.object,
  preferredCommunications: PropTypes.array,
  onPhoneChange: PropTypes.func,
  preferredCommunicationLanguages: PropTypes.array,
  defaultLanguageId: PropTypes.string,
  isEditMode: PropTypes.bool,
  languageTranslations: PropTypes.object,
};

export default (injectIntl(ContactInformation));